<template>
  <div>
    <BulkSendInvoice :dateFrom="dateFrom" :dateTo="dateTo" @sended="initList"/>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.sale_management')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('invoice.archive_invoice')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap align-items-center">
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="master_clients.find(m => m.id === client_id) || ''"
              :options="master_clients"
              label="name"
              :placeholder="translations('invoice.supplier')"
              :id="client_id"
              @input="changedClients">
            </v-select>
          </div>
          <div class="form-group mr-3">
            <div class="dropdown">
              <button id='filterByBilling' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{translations('invoice.invoice_status')}}</button>
              <div class="dropdown-menu">
                <a class='dropdown-item' v-on:click='billing_status_id=0'>{{translations('invoice.invoice_status')}}</a>
                <a class='dropdown-item' v-for='(billing, i) in billingStatuses' :key='i' v-on:click='billing_status_id=billing.id'>{{ billing.name }}</a>
              </div>
            </div>
          </div>
          <div class="form-group mr-3 d-flex flex-wrap">
            <span class="mr-1">{{ translations('common.period') }}</span>
<!--            <input v-model="dateFrom" type="date" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateField = dateFrom">-->
            <input v-model="dateFrom" type="date" class="form-control">
            <span class="mr-1 ml-1">〜</span>
<!--            <input v-model="dateTo" type="date" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateField = dateTo">-->
            <input v-model="dateTo" type="date" class="form-control">
          </div>
          <div class="form-group ml-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{ translations('common.display_all') }}
              </label>
            </div>
          </div>
          <div class="form-group ml-2">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
        <div class="form-group" style="margin-left: auto">
          <div class="form-group" style="margin: 1px 0 0 0">
            <button class="btn btn-primary btn-sm" type="button" @click="exportCsv">{{translations('common.csv_export')}}</button>
          </div>
          <div class="form-group">
            <button class="btn btn-link btn-sm decoration-underline" type="button" data-toggle="modal" data-target="#BulkSendInvoice">{{translations('invoice.batch_delivery_of_invoices')}}</button>
          </div>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-1300 table-clickable"
          item-key="id"
          :headers="[
            { text: 'No', sortable: false },
            { text: this.translations('invoice.invoice_status'), value: 'billing_status' },
            { text: this.translations('invoice.billing_date'), value: 'billed_at' },
            { text: this.translations('invoice.billing_number'), value: 'billing_number' },
            { text: this.translations('invoice.supplier'), value: 'younosuke_company_name' },
            { text: this.translations('invoice.purchase_total'), value: 'total_amount_inctax' },
            { text: this.translations('invoice.billing_amount'), value: 'balance' },
            { text: this.translations('invoice.expected_payment'), value: 'payment_schedule_at' },
            { text: this.translations('invoice.deposited'), value: 'payment_at' },
            { text: this.translations('invoice.remarks'), value: 'memo' },
          ]"
          :items="invoices"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr  v-for="(invoice, i) in items" :key='i' data-href="" @click="openSingleInvoices(invoice)">
                  <td>{{i + 1}}</td>
                  <td>
                    <span class="badge" :class="billingStatusesBadge[Number(invoice.billing_status) - 1]">
                      {{ billingStatuses[Number(invoice.billing_status) - 1].name }}
                    </span>
                  </td>
                  <td>{{ $invoiceTools.formatDate(invoice.billed_at) }}</td>
                  <td>{{ invoice.billing_number }}</td>
                  <td>{{ invoice.client }}</td>
                  <td class="right">{{ Number(invoice.total_amount).toLocaleString() }}</td>
                  <td class="right">{{ Number(invoice.balance).toLocaleString() }}</td>
                  <td>{{ $invoiceTools.formatDate(invoice.payment_schedule_at) }}</td>
                  <td>{{ $invoiceTools.formatDate(invoice.payment_at) }}</td>
                  <td>{{ invoice.memo }}</td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import BulkSendInvoice from '@/components/BulkSendInvoiceModal'
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
import Papa from 'papaparse'
import encoding from 'encoding-japanese'

export default {
  name: 'ArchiveInvoices',
  props: {},
  components: {
    VueElementLoading,
    BulkSendInvoice
  },
  data () {
    return {
      dtSearch: '',
      isSearching: false,
      billingStatuses: [],
      billing_status_id: 0,
      client_id: 0,
      dateFrom: '',
      dateTo: '',
      invoices: [],
      isEmpty: false,
      isEmptyMsg: '',
      // tempDateField: '',
      billingStatusesBadge: ['badge-success', 'badge-warning', 'badge-light'],
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      displayAll: false
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    master_clients () {
      return this.$store.getters['Master/getBillTo']
    },
    translatedShipmentStatusList () {
      return this.billingStatuses.map(status => ({
        ...status,
        name: this.translations(`invoice.${status.name}`)
      }))
    }
  },
  watch: {
    // client_id () {
    //   this.initList()
    // },
    billing_status_id (newVal) {
      // this.initList()
      this.selectBilling(newVal)
    },
    currentLanguage (newLang) {
      this.listBillingStatuses().catch(err => {
        this.$toastr.error(err.message, this.translations('common.error'))
      })
    },
    page () {
      this.getFilterdList()
    },
    options: {
      handler () {
        let visitCount = Number(localStorage.getItem('visitCountInvoices')) || 0
        if (visitCount > 0) {
          this.initList()
        }
      },
      deep: true
    }
  },
  created: function () {
    this.$store.dispatch('Master/checkBillTo')
    let storedFilter = this.$storage.get('ArchiveInvoicesParam')
    console.log('storedFilter.clients_id', storedFilter.clients_id)

    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.billing_status_id = parseInt(storedFilter.billing_status_id)
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      this.client_id = storedFilter.client_id
      this.options.sortBy = storedFilter.orderbys
      this.options.sortDesc = storedFilter.is_descs
    }

    Promise.all([
      this.listBillingStatuses()
    ]).catch(err => {
      this.$toastr.error(err.message, this.translations('common.error'))
    })
  },
  methods: {
    // changeSearch (e) {
    //   console.log(e.target.value)
    //   this.$storage.set('ArchiveInvoices:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.initList()
    //   }
    // },

    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterdList()
      }
    },

    getFilterdList () {
      if (this.displayAll) {
        this.$storage.set('invoice_display_all', this.displayAll)
        this.options.itemsPerPage = -1 // DISPLAY ALL
      } else {
        this.options.itemsPerPage = 10 // DISPLAY 10 ROWS
      }

      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      // let search = this.dtSearch
      // if (this.client_id) {
      //   search = ''
      // }
      let params = {
        client_id: this.client_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        billing_status_id: this.billing_status_id,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }
      this.$storage.set('ArchiveInvoicesParam', params)
      console.log('ArchiveInvoices:getFilterdList: ', params)

      return this.$http.post(this.$api_url.invoices_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.invoices = result.list
          localStorage.setItem('visitCountInvoices', this.invoices.length)
          this.totalCount = Number(result.total_count)
          return Promise.resolve()
        } else {
          this.invoices = []
          this.$toastr.error(result.message, this.translations('common.error'))
          return Promise.reject(new Error(result.message))
        }
      }).catch(e => {
        console.log('ArchiveInvoices:API:getFilterdList: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('invoice.notice_failed')
        return Promise.reject(new Error(this.isEmptyMsg))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    listBillingStatuses () {
      return this.$http.post(this.$api_url.billing_status).then(response => {
        const result = response.data
        if (result.status === true) {
          this.billingStatuses = result.list.map(status => {
            return {
              ...status,
              name: this.translations(`invoice.${status.name}`)
            }
          })
        } else {
          this.billingStatuses = [{ id: 0, name: 'No record.' }]
        }
        this.selectBilling(this.billing_status_id)
      }).catch(e => {
        console.log('ArchiveInvoices:API:listBillings: error: ', e)
        return Promise.reject(new Error(this.translations('invoice.notice_failed')))
      })
    },

    selectBilling (billingStatusId) {
      if (billingStatusId === 0) {
        window.$('#filterByBilling').text(this.translations('invoice.invoice_status'))
        return
      }

      const selectedStatus = this.billingStatuses.find(v => v.id === billingStatusId)
      if (selectedStatus) {
        window.$('#filterByBilling').text(selectedStatus.name)
      }
    },

    getFilterTxt (obj, input, output, _default) {
      if (input) {
        if (input === 0) return _default
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    openSingleInvoices (invoice) {
      this.$router.push({ name: 'single-invoices', query: { billing_id: invoice.id } })
    },

    changedClients (event) {
      if (!event) {
        this.client_id = 0
        return
      }
      this.client_id = event.id
    },

    submitSearch () {
      this.initList()
    },

    exportCsv () {
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      let params = {
        client_id: this.client_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        billing_status_id: this.billing_status_id,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch
      }
      console.log('ArchiveInvoices:exportCsv: ', params)

      return this.$http.post(this.$api_url.invoices_csv, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.saveCsv_(result.list)
          return Promise.resolve()
        } else {
          this.invoices = []
          this.$toastr.error(result.message, this.translations('common.error'))
          return Promise.reject(new Error(result.message))
        }
      }).catch(e => {
        console.log('ArchiveInvoices:API:exportCsv: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('invoice.notice_failed')
        return Promise.reject(new Error(this.isEmptyMsg))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    saveCsv_ (list) {
      const data = []
      list.forEach(item => {
        const billingStatus = this.billingStatuses[Number(item.billing_status) - 1].name
        data.push([
          billingStatus,
          item.billed_at,
          item.billing_number,
          item.client,
          item.total_amount,
          item.balance,
          item.payment_schedule_at,
          item.payment_at,
          item.memo
        ])
      })
      let csv = ''
      csv = Papa.unparse({
        fields: [
          this.translations('invoice.invoice_status'),
          this.translations('invoice.billing_date'),
          this.translations('invoice.billing_number'),
          this.translations('invoice.supplier'),
          this.translations('invoice.purchase_total'),
          this.translations('invoice.billing_amount'),
          this.translations('invoice.expected_payment'),
          this.translations('invoice.deposited'),
          this.translations('invoice.remarks')
        ],
        data: data
      })

      const unicodeList = encoding.stringToCode(csv)
      const sjisArray = encoding.convert(unicodeList, 'SJIS', 'UNICODE')
      const uInt8List = new Uint8Array(sjisArray)
      const content = new Blob([uInt8List], { type: 'text/csv' })
      const d = new Date()
      const filename = this.translations('invoice.invoice_') + d.getFullYear() +
        ('0' + (d.getMonth() + 1)).slice(-2) +
        ('0' + d.getDate()).slice(-2) + '_' +
        ('0' + d.getHours()).slice(-2) +
        ('0' + d.getMinutes()).slice(-2) +
        ('0' + d.getSeconds()).slice(-2) + '.csv'
      saveAs(content, filename)
      this.isLoading = false
    }
  }
}
</script>

<style>
#tbl-invoices_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
